var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"id":"a","href":_vm.mailto}})}
var staticRenderFns = []

export { render, staticRenderFns }